// --------------------------------------------------------------------------
// # Reveal and hide text block
//   Handles toggling elements visibility within the reveal and hide text block
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context,
        openClass = 'is-open';

    function init() {
        context.find('.reveal-and-hide-text-block__heading').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass(openClass);
            $(this).next().slideToggle();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/reveal-and-hide-text-block.js
// module id = 250
// module chunks = 0